import styled from "styled-components";

import { Button, Dropdown, Form, Input, Label } from "semantic-ui-react";
import React, { useState, useRef, useEffect, useMemo } from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { getDirectories, uploadFiles } from "../../redux/modules/file";
import { t } from "../../constant/translations";

type Props = {
  block: Object,
  dirs: string,
  currentFiles: int,
  loading: ?boolean,
};

const StyledDropdown = styled(Dropdown)`
  min-height: 44px !important;
`;

const StyledButton = styled(Button)`
  margin: 0 !important;
  min-height: 44px !important;
`;

const UploadFormComponent = ({
  block,
  dirs,
  currentFiles,
  loading,
  uploadFiles,
}: Props) => {
  const [state, setState] = useState({
    files: null,
    dirOptions: null,
    dir: t("file.common"),
  });
  const fileInput = useRef(null);

  useEffect(() => {
    if (fileInput.current) {
      fileInput.current.value = "";
    }
    setState({ ...state, files: null, dir: t("file.common") });
  }, [currentFiles]);

  const handleUpload = () => {
    if (state.files) {
      uploadFiles(
        {
          block: block.id,
          directory_name: state.dir,
        },
        state.files
      );
    }
  };

  const options = useMemo(() => {
    const builtInOptions = (dirs || []).map((dir) => ({
      key: dir,
      text: dir,
      value: dir,
    }));

    const customOptions = state.dirOptions || [];

    const merged = [...builtInOptions, ...customOptions];
    const seen = new Set();
    return merged.filter(({ value }) => {
      if (seen.has(value)) return false;
      seen.add(value);
      return true;
    });
  }, [dirs, state.dirOptions]);

  return (
    <Form>
      <Form.Field>
        <label>{t("file.document_select")}</label>
        <input
          className="dropzone"
          type="file"
          multiple
          ref={fileInput}
          onChange={(e) =>
            setState({ ...state, files: Array.from(e.target.files) })
          }
        />
      </Form.Field>
      <Form.Group widths="equal" style={{ alignItems: "flex-end" }}>
        <Form.Field>
          <label>{t("file.directory")}</label>
          <StyledDropdown
            name="dir"
            options={options}
            placeholder={t("file.folder")}
            search
            selection
            fluid
            allowAdditions
            value={state.dir}
            onAddItem={(e, { value }) => {
              setState({
                ...state,
                dirOptions: [
                  { text: value, value },
                  ...(state.dirOptions || []),
                ],
              });
            }}
            onChange={(e, { value }) => setState({ ...state, dir: value })}
          />
        </Form.Field>
        <Form.Field>
          <StyledButton
            fluid
            primary
            type="submit"
            onClick={handleUpload}
            loading={loading}
            disabled={!state.files || loading}
          >
            {t("file.attach")}
          </StyledButton>
        </Form.Field>
      </Form.Group>
    </Form>
  );
};

function mapStateToProps(state) {
  return {
    block: state.blocks.selected,
    dirs: getDirectories(state.file.entities),
    currentFiles: state.file.entities ? state.file.entities.length : 0,
    loading: state.file.pending,
  };
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators({ uploadFiles }, dispatch);
}

export const UploadForm = connect(
  mapStateToProps,
  mapDispatchToProps
)(UploadFormComponent);
